import { useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { dateFormats, moment } from "@payping/utils/dateUtils";
import { Divider, Flex, Grid, Space, Typography } from "@payping/web-components";
import { useRef } from "react";

interface Contract {
  issue?: string;
}
export default function SignContractContract(props: Contract) {
  const { t } = useAppTranslation();
  const personalInfo = useAppSelector((state) => state.user.personalInfo);
  const businessInfo = useAppSelector((state) => state.user.businessInfo);
  const localInfo = useAppSelector((state) => state.user.localInfo);
  const shebaId = useAppSelector((state) => state.user.bankInfo?.sheba);
const date  = useRef(moment(new Date()));
  const { md } = Grid.useBreakpoint();

  return (
    <div id="contract_content" className="p-1">
      <Flex style={{width:'100%'}} justify="end" vertical align="end">
      <Typography.Paragraph>{`${t("signContract.number")} : ${personalInfo?.id}${date.current.unix()}`}</Typography.Paragraph>
      <Typography.Paragraph>{`${t("signContract.date")} : ${(date.current).format(dateFormats.ui.jalaliDate)}`}</Typography.Paragraph>
      </Flex>
      <Typography.Title level={4}>{t("signContract.articleOne.title")}</Typography.Title>
      <Typography.Paragraph>{t("signContract.articleOne.one")}</Typography.Paragraph>
      <Typography.Paragraph>
        {t("signContract.articleOne.two", {
          fullName: `${personalInfo?.firstName || ""} ${personalInfo?.lastName || ""}`,
          fatherName: personalInfo?.fatherName || "",
          nationalCode: personalInfo?.nationalCode || "",
          economicCode: businessInfo?.economicCode || "",
          address: localInfo?.address,
          businessDescription: businessInfo?.businessDescription || "",
        })}
      </Typography.Paragraph>
      <Typography.Title level={4}>{t("signContract.articleTwo.title")}</Typography.Title>
      <Typography.Paragraph>
        {t("signContract.articleTwo.one", { websiteAddress: businessInfo?.site })}
      </Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleTwo.two")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleTwo.three")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleTwo.four")}</Typography.Paragraph>

      <Typography.Title level={4}>{t("signContract.articleThree.title")}</Typography.Title>
      <Typography.Paragraph>{t("signContract.articleThree.one")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleThree.two")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleThree.three")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleThree.four")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleThree.five")}</Typography.Paragraph>

      <Typography.Title level={4}>{t("signContract.articleFour.title")}</Typography.Title>
      <Typography.Paragraph>{t("signContract.articleFour.one")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.two")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.three")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.four", { sheba: shebaId })}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.five")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.six")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.seven")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.eight")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.nine")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.ten")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.evelen")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.twelve")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.thirteen")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.fourteen")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.fifteen")}</Typography.Paragraph>
      <Typography.Paragraph>{t("signContract.articleFour.sixteen")}</Typography.Paragraph>
      <Space
        className="w-100 mt-2"
        style={{ justifyContent: "space-between" }}
        direction={md ? "horizontal" : "vertical"}
        size={"large"}
      >
        <div>
          <Typography.Paragraph className="m-0">{t("signContract.ctoName")}</Typography.Paragraph>
          <Typography.Paragraph className="m-0">{t("signContract.ctoTitle")}</Typography.Paragraph>
          <Divider style={{ margin: "8px 0" }} />
          <Typography.Paragraph className="m-0">{t("signContract.cbdName")}</Typography.Paragraph>
          <Typography.Paragraph className="m-0">{t("signContract.cbdTitle")}</Typography.Paragraph>
        </div>
        <div>
          <Typography.Paragraph className="m-0">
            {t("signContract.acceptor", { acceptorName: businessInfo?.businessName || "" })}
          </Typography.Paragraph>

          <Divider style={{ margin: "8px 0" }} />
          <div style={props.issue ? { width: "300px", height: "200px" } : undefined}>
            {props.issue ? <img src={props.issue} className="w-100 h-100" /> : t("signContract.issuePlaceholder")}
          </div>
        </div>
      </Space>
    </div>
  );
}
